module.exports = __webpack_public_path__ + "img/cloud_up.edcde291.png";